import { DateRangeFilterEnum as e } from "../types/date-range-filter-enum.js";
import { getDate as t, setDateWithTimezone as n, toISOStringWithoutTimezone as r } from "../utils/date-utils.js";
import { setDateSince as i } from "../utils/set-date-since.js";
import { setDateTill as a } from "../utils/set-date-till.js";
import { applyMaxInterval as o } from "./utils/apply-max-interval.js";
import { setActiveFilterValue as s } from "./utils/set-active-filter-value.js";
import { getDefaultCustomFilter as c } from "./utils/set-custom-filter.js";
import { useEffect as l, useMemo as u, useState as d } from "react";
//#region src/date-picker/date-range-picker/use-date-range.ts
function f({ customFilters: f, date: p, intlLocale: m, maxInterval: h, minDate: g, timezone: _, getDefaultDate: v, onChange: y }) {
	let b = u(() => g ? r(g) : void 0, [g]), x = b ? t(b, _) : void 0, S = u(() => f || (b && _ ? [c(b, _)] : []), [
		f,
		b,
		_
	]), C = (e) => !m || !b || !e ? e : t(b) > t(e) ? b : e, w = C(p[0]), T = p[1], [E, D] = d(), [O, k] = d(), [A, j] = d([w ? n(w, _) : null, T ? n(T, _) : null]), [M, N] = d(w ? n(w, _) : null), [P, F] = d(T ? n(T, _) : null);
	l(() => {
		let e = w ? n(w, _) : null, t = T ? n(T, _) : null;
		j([e, t]), N(e), F(t);
	}, [
		w,
		T,
		_
	]), l(() => {
		!O || !_ || s({
			activeFilter: O,
			customFilters: S,
			setDateRange: j,
			timezone: _
		});
	}, [
		O,
		S,
		_
	]);
	let [I, L] = A;
	return {
		activeFilter: O,
		appliedDateSince: M,
		appliedDateTill: P,
		filterPresets: [
			e.Last30Days,
			e.ThisMonth,
			e.LastMonth,
			...S.map((e) => e.slug)
		],
		handleApply: () => {
			let [e, t] = A;
			e && t ? (N(e), F(t), D(O), i(e), a(t), y([r(e), r(t)])) : y([null, null]);
		},
		handleChange: (e) => {
			if (!Array.isArray(e)) return;
			k(void 0);
			let [t, n] = e, r = h ? o(t, n, h) : [t, n];
			j(r);
		},
		handleClear: () => {
			if (v) {
				let [e, t] = v(), i = C(e) ?? void 0, a = n(i, _), o = n(t, _);
				j([a, o]), N(a), F(o), y([r(a), r(o)]);
			} else j([null, null]), N(null), F(null), y([null, null]);
			k(void 0), D(void 0);
		},
		minAllowedDate: b,
		resolvedMinDate: x,
		resetDraftRange: () => {
			j([M, P]), k(E);
		},
		selectedDateSince: I,
		selectedDateTill: L,
		setActiveFilter: k
	};
}
//#endregion
export { f as useDateRange };
